import { Grid, Typography, Box } from "@mui/material";
import React from "react";
import earth from "../../../../assets/earth.png";
import playground from "../../../../assets/playground.png";
import rooms from "../../../../assets/rooms.png";


const InfoPage = () => {
  return (
    <>
      <Grid
        container
        id="about"
        spacing={2}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: { xs: 5, md: 10 },
          gap: 2,
        }}
      >
        <Grid item xs={12} md={12}>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "25px", md: "30px", textAlign: "center", mb: 2 },
            }}
          >
            About our PreSchool
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: "1.6",
              textAlign: { xs: "justify", md: "center" },
            }}
          >
            Join the fun-filled journey of learning and laughter at Yelahanka's
            biggest Podar Prep Preschool, where every day is an exciting new
            chapter for your little one.
          </Typography>
        </Grid>
        {[
          {
            title: "CLEAN ENVIRONMENT",
            description:
              "State-of-the-Art Facilities - Our preschool boasts modern amenities designed to inspire and engage young learners.",
            image: earth,
          },
          {
            title: "BIG PLAYGROUND & AREA",
            description:
              "Expansive Playgrounds - Where laughter echoes and friendships blossom, our vast outdoor spaces offer endless opportunities for active play and exploration.",
            image: playground,
          },
          {
            title: "CLASSROOMS",
            description:
              "Thoughtfully Designed Classrooms provides good environment from cozy reading corners to play zones for your child's development.",
            image: rooms,
          },
        ].map((item, index) => (
          <Grid
            item
            key={index}
            from="home-button"
            sx={{
              mt: 2,
              padding: "10px",
              border: "1px solid #1d67ab",
              backgroundColor: "#1d67ab",
              display: "flex",
              flexDirection: "column",
              width: "350px",
              height: { xs: "250px", md: "300px" },
              justifyContent: "center",
              alignItems: "center",
              boxShadow: 10,
              borderRadius: "8px",
              textAlign: "center",
            }}
          >
            <img
              src={item.image}
              alt={item.title}
              style={{
                width: "100px",
                height: "100px",
                marginBottom: { xs: 5, md: 8 },
                filter: "invert(1)",
              }}
            />

            <Typography
              sx={{
                color: "#fff",
                fontWeight: "bold",
                fontSize: { xs: "20px", md: "20px" },
                marginBottom: 2,
              }}
            >
              {item.title}
            </Typography>

            <Typography
              sx={{
                color: "#fff",
                fontWeight: "bold",
                fontSize: "12px",
              }}
            >
              {item.description}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default InfoPage;
